import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import {
  getVisualEmailBuilderStyleMap,
  resolveVariableValuesFromStyleObject,
} from "./getVisualEmailBuilderStyleMap";

export const useParseStyles = ({
  baseStyles = {},
  styles,
  defaultStyles,
}: {
  /** To be applied on the element directly. These properties are not editable on the design panel. */
  baseStyles?: Record<string, unknown>;
  /** Applied via the design panel. */
  styles: Record<string, StyleValue>;
  /** Default styles for the block. parseStyles iterates on styles, so only values in styles are considered. Other values are ignored. */
  defaultStyles: Record<string, unknown>;
}) => {
  const currentCanvasTheme = useBuilderStore(state => state.currentCanvasTheme);

  const inlineStyles = parseStyles({
    styles,
    defaultStyles,
    ignoreDefaults: false,
    styleMap: getVisualEmailBuilderStyleMap(currentCanvasTheme),
  });

  const elementStyles = {
    ...baseStyles,
    ...inlineStyles,
  };

  return resolveVariableValuesFromStyleObject({
    styleObject: elementStyles,
    currentTheme: currentCanvasTheme,
  });
};
